import { JwtPayload } from "jwt-decode";

interface LoginRequest {
    username: string;
    password: string;
}

interface RefreshRequest {
    refresh_token: string | undefined;
    orgId: string;
}


interface LoginResponse {
    access_token: string;
    expires_in: number;
    refresh_token: string;
    refresh_expires_in: number;
    token_type: string;
    'not-before-policy': number;
    session_state: string;
    scope: string;
}

type JwtClaims = JwtPayload & {
    preferred_username: string;
    organization: Map<string, any>;
}

interface VerifyRequest {
    username: string;
    orgId: string;
}

export const isLoginResponse = (error: any): error is LoginResponse =>
    typeof error === 'object' && error !== null &&
    Object.prototype.hasOwnProperty.call(error, 'access_token') && typeof error.access_token === 'string' &&
    Object.prototype.hasOwnProperty.call(error, 'refresh_token') && typeof error.refresh_token === 'string';

export type { LoginRequest, RefreshRequest, LoginResponse, JwtClaims, VerifyRequest };
